import React, { Fragment, useState } from "react";

export const DurationSlider = () => {
  const [slideValue, setSlideValue] = useState(3);
  const handleSlideChange = (event) => {
    const value = event.target.value;
    if (value >= 1 && value <= 5) {
      setSlideValue(parseInt(value, 10));
    }
  };
  return (
    <Fragment>
      <div className="row">
        <div className="col-12">
          <h2 className="text-primary ss-title pb-2">
            <strong>
              <strong>Select the Duration of your Plan</strong>
            </strong>
          </h2>
        </div>
        <div className="col-12 col-md-8">
          {/* <h4 className="pb-4 ss-paragraph text-ss-dark">
            Select the duration of your plan.
          </h4> */}
        </div>
        <div className="col-12 col-md-4 text-right">
          <h4 className="pb-4 ss-sub-title text-ss-dark">
            <strong>{slideValue} years</strong>
          </h4>
        </div>
      </div>
      <div className="slidecontainer pb-5">
        <input
          type="range"
          min="1"
          max="5"
          step="1"
          value={slideValue}
          className="slider w-100"
          name="duration"
          id="duration"
          onChange={handleSlideChange}
        />
        <div className="flex-row justify-content-between px-0">
          <h6>1</h6>
          <h6>5</h6>
        </div>
      </div>
    </Fragment>
  );
};
export default DurationSlider;



// WEBPACK FOOTER //
// ./resources/assets/js/app/DurationSlider/index.js